/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable import/no-unresolved */
import { useLazyQuery, useReactiveVar } from '@apollo/client';
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tooltip } from 'appkit-react';

import {
    showReportMenuVar, getPreviousBatchVar, showBatchAlertVar,
    leftNavigationItemsVar, moduleIdVar, currentLeftMenuVar,
} from 'Apollo/config';
import {
    GET_BATCH_TEST_FOR_METRO2, GET_METRO2_DOWNLOADED_RESULT, GET_MONTH_FILTERED_BATCH_TESTS_FOR_METRO2,
    GET_LATEST_BATCH_FOR_METRO2,
} from 'Apollo/Queries/Rules/Metro2Results';
import { ModuleEnum } from 'constants';
import DiagnosticResultsUI from 'views/DiagnosticResults/components';
import crossReportImg from 'assets/images/cross-report-black.svg';
import StatusComponent from '../../../DiagnosticResults/components/StatusComponent';

const listItems = [
    [
        <i key={1} className="appkiticon icon-bar-chart-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem', color: '#464646' }}>Data Reconciliation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-ticket-outline" style={{ fontSize: '1.5rem', color: 'white', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ fontSize: '0.7rem' }}>Rule Engine</span>,
    ],
    [
        <img
            key={1}
            src={crossReportImg}
            alt="Cross Report"
            style={{
                width: '30.84px', height: '25px', top: '100px',
            }}
        />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Cross Report Validation</span>,
    ],
    [
        <i key={1} className="appkiticon icon-grow-revenue-outline" style={{ fontSize: '1.5rem', color: '#464646', top: '100px' }} />,
        <span key={2} className="a-nav-item-text" style={{ color: '#464646', fontSize: '0.7rem' }}>Trend Analytics</span>,
    ],
];

const Metro2LandingPage = () => {
    const pageName = 'Metro2 Diagnostic Results';
    const history = useHistory();
    const location = useLocation();
    const [regulation, setRegulation] = useState(location.state.regulation);
    const showBatchAlert = useReactiveVar(showBatchAlertVar);
    const [oneTimeFlag, setOneTimeFlag] = useState(true);
    const [showSuccessAlert, setShowSuccessAlert] = useState(false);
    const [queryError, setQueryError] = useState(false);
    const [selectedQuarter, setSelectedQuarter] = useState('');
    const getPreviousBatch = useReactiveVar(getPreviousBatchVar);

    /* Apollo query to fetch batch tests result  */
    const [getBatchTestData, { loading: isLoading, data }] = useLazyQuery(GET_BATCH_TEST_FOR_METRO2, {
        variables: {
            input: {
                pageNumber: 1,
                pageSize: 10000,
                getPreviousBatch,
            },
        },
        fetchPolicy: 'no-cache',
    });

    const [getCurrentStatusOfLatestBatch, {
        data: { getCurrentStatusOfLatestBatchForMETRO2 = {} } = {}, error: getCurrentStatusOfLatestBatchError, stopPolling,
    }] = useLazyQuery(GET_LATEST_BATCH_FOR_METRO2, {
        pollInterval: 20000,
        fetchPolicy: 'no-cache',
    });

    /* Apollo query fetch batch test result selected period  */
    const [getMonthFilteredData, filteredBatchTests] = useLazyQuery(GET_MONTH_FILTERED_BATCH_TESTS_FOR_METRO2, {
        fetchPolicy: 'no-cache',
    });

    /* Apollo query to download batch test result  */
    const [getDownloadedResult, { loading: isDownloading, data: { getMETRO2SummaryDetailsForDownload = {} } = {} }] = useLazyQuery(GET_METRO2_DOWNLOADED_RESULT, {
        fetchPolicy: 'no-cache',
    });

    /** Calls  getDownloadedResult() */
    const downloadResult = () => {
        const month = selectedQuarter.getMonth() + 1;
        const year = selectedQuarter.getFullYear();
        const monthValue = `${month}_${year}`;
        getDownloadedResult({
            variables: {
                input: {
                    period: monthValue,
                },
            },
        });
    };

    const getLatestBatch = () => {
        stopPolling();
        getPreviousBatchVar(false);
        setShowSuccessAlert(false);
    };

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">Metro2 Diagnostic Results</span>,
        },
    ];

    /* Navigates to result page of specific rule */
    const onNavigateToResult = row => {
        history.push(
            {
                pathname: '/metro2Result',
                state: {
                    batchId: row.batchId,
                    ruleId: row.ruleId,
                    regulation,
                },
            },
        );
    };

    /* Method for sidebar navigation */
    const onNavigate = () => {
        // method for sidebar navigation
    };

    /* Navigates to upload report page */
    const uploadReport = () => {
        history.push(
            {
                pathname: '/UploadReport',
            },
        );
    };

    /* status component fetched from diagonstic result folder */
    const getSpanStyle = status => (
        <StatusComponent
            status={status}
        />
    );

    /* Column configuration for batch test summary table */
    const columns = [
        {
            Header: 'Rule ID',
            accessor: 'ruleId',
            minWidth: 70,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Field Name',
            accessor: 'fieldName',
            minWidth: 220,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Rule Description',
            accessor: 'ruleDescription',
            minWidth: 320,
            resizable: true,
            sortable: true,
            Cell: row => (
                <Tooltip
                    content={row.original.ruleDescription}
                    placement="top"
                    tooltipTheme="light"
                    trigger="hover"
                    style={{ width: '300px', wordWrap: 'break-word' }}
                >
                    <div
                        style={{
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                            width: '300px',
                            display: 'block',
                            overflow: 'hidden',
                            cursor: 'pointer',
                        }}
                    >
                        {row.original.ruleDescription}
                    </div>
                </Tooltip>
            ),
        },
        {
            Header: 'Is Active',
            accessor: 'isActive',
            minWidth: 80,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Total Rows',
            accessor: 'totalRecords',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Passed Rows',
            accessor: 'testPass',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Failed Rows',
            accessor: 'testFail',
            minWidth: 100,
            resizable: true,
            sortable: true,
        },
        {
            Header: 'Test status',
            accessor: 'testRunStatus',
            minWidth: 90,
            resizable: true,
            sortable: true,
            Cell: row => {
                const { original: { testRunStatus } } = row;
                return getSpanStyle(testRunStatus);
            },
        },
    ];

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        currentLeftMenuVar(ModuleEnum.RULEENGINE);
    }, []);

    /* Side effect when location state updates */
    useEffect(() => {
        setRegulation(location.state.regulation);
        showReportMenuVar(true);
    }, [location]);

    /* Side effect when getPreviousBatch changed */
    useEffect(async () => {
        getBatchTestData();
        if (getPreviousBatch === true) {
            getCurrentStatusOfLatestBatch();
        }
    }, [getPreviousBatch]);

    /* Side effect when getCurrentStatusOfLatestBatchForMETRO2 changed */
    useEffect(() => {
        const isCurrentStatusForLatestBatchAvailable = getCurrentStatusOfLatestBatchForMETRO2.length > 0 && Object.keys(getCurrentStatusOfLatestBatchForMETRO2[0]).length > 0;

        if (isCurrentStatusForLatestBatchAvailable && (
            (getCurrentStatusOfLatestBatchForMETRO2[0]).batchRunStatus === 'Completed'
                || (getCurrentStatusOfLatestBatchForMETRO2[0]).batchRunStatus === 'Failed')) {
            showBatchAlertVar(false);
            stopPolling();
        }
        if (isCurrentStatusForLatestBatchAvailable && (getCurrentStatusOfLatestBatchForMETRO2[0]).batchRunStatus === 'Completed') {
            setShowSuccessAlert(true);
        }
    }, [getCurrentStatusOfLatestBatchForMETRO2, stopPolling]);

    /* Side effect when getCurrentStatusOfLatestBatchError changed */
    useEffect(() => {
        if (getCurrentStatusOfLatestBatchError) {
            stopPolling();
            setQueryError(true);
            showBatchAlertVar(false);
        }
    }, [getCurrentStatusOfLatestBatchError, stopPolling]);

    /* Side effect when batchTestData changed to set selected quarter */
    useEffect(() => {
        if (data?.getBatchTestsForMETRO2 && data?.getBatchTestsForMETRO2.length > 0) {
            const monthValue = data.getBatchTestsForMETRO2[0].period;
            const month = monthValue && monthValue.split('_')[0] - 1;
            const year = monthValue && monthValue.split('_')[1];
            const date = new Date(year, month, 1);
            setSelectedQuarter(date);
        } else {
            setSelectedQuarter(new Date());
        }
    }, [data]);

    /* Side effect when selectedQuarter changed to refetch batch tests result */
    useEffect(() => {
        if (selectedQuarter !== '' && !getPreviousBatch) {
            const month = selectedQuarter.getMonth() + 1;
            const year = selectedQuarter.getFullYear();
            const monthValue = `${month}_${year}`;
            getMonthFilteredData({
                variables: {
                    input: {
                        period: monthValue,
                        pageNumber: 1,
                        pageSize: 100,
                    },
                },
            });
            setOneTimeFlag(false);
        }
    }, [selectedQuarter, getPreviousBatch]);

    /* Side effect when getMETRO2SummaryDetailsForDownload changed */
    useEffect(() => {
        if (getMETRO2SummaryDetailsForDownload && getMETRO2SummaryDetailsForDownload.length > 0) {
            const json = getMETRO2SummaryDetailsForDownload;
            const fields = Object.keys(json[0]);
            const replacer = (key, value) => (value === null ? '' : value);
            let csv = json.map(row => fields.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
            csv.unshift(fields.join(','));
            csv = csv.join('\r\n');
            const blob = new Blob([csv], { type: 'text/csv' });
            saveAs(blob, `${regulation}_result.csv`);
        }
    }, [getMETRO2SummaryDetailsForDownload]);

    return (
        <DiagnosticResultsUI
            downloadResult={downloadResult}
            breadcrumbItems={breadcrumbItems}
            pageName={pageName}
            onNavigate={onNavigate}
            onNavigateToResult={onNavigateToResult}
            commonData={oneTimeFlag ? (data && data.getBatchTestsForMETRO2) : (filteredBatchTests.data && filteredBatchTests.data.getMETRO2BatchTestsByMonth)}
            columns={columns}
            uploadReport={uploadReport}
            isDownloading={isDownloading}
            isBatchTestDataLoading={isLoading}
            latestBatch={getCurrentStatusOfLatestBatchForMETRO2}
            getPreviousBatch={getPreviousBatch}
            showSuccessAlert={showSuccessAlert}
            getLatestBatch={getLatestBatch}
            showBatchAlert={showBatchAlert}
            queryError={queryError}
            selectedQuarter={selectedQuarter}
            setSelectedQuarter={setSelectedQuarter}
        />
    );
};

export default Metro2LandingPage;
